import store from '@/store';

import {
  refreshAxiosInstance,
  refreshSubUserAxiosInstance,
  refreshSpotifyInstance,
  refreshSpotifyUserInstance,
} from '@/bootstrap/axios';

import {
  DEFAUL_USER_TYPE,
} from '@/bootstrap/types';

window.eventBus.$on('authenticated', () => {
  console.log('Event - authenticated');
  refreshAxiosInstance();
  store.dispatch('fetchEvents');
});

window.eventBus.$on('subUserAuthenticated', () => {
  console.log('Event - subUserAuthenticated');
  refreshSubUserAxiosInstance();
});

window.eventBus.$on('receivedSpotifyAccessToken', () => {
  console.log('Event - receivedSpotifyAccessToken');
  refreshSpotifyInstance();
});

window.eventBus.$on('receivedSpotifyUserAccessToken', () => {
  console.log('Event - receivedSpotifyUserAccessToken');
  refreshSpotifyUserInstance();
  store.dispatch('fetchSpotifyUser');
});

// eslint-disable-next-line camelcase
window.eventBus.$on('userInitialized', ({ user_type }) => {
  console.log('Event - userInitialized');
  // eslint-disable-next-line camelcase
  if (user_type === DEFAUL_USER_TYPE) {
    store.dispatch('fetchNotifications');
  }
});
